import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingCTA from "./FloatingCTA";
import Breadcrumbs from "./Breadcrumbs";

import { useVisitTracker } from "@/hooks/useVisitTracker";

interface LayoutProps {
  children: ReactNode;
  breadcrumbTitle?: string;
  hideBreadcrumbs?: boolean;
}

const Layout = ({ children, breadcrumbTitle, hideBreadcrumbs }: LayoutProps) => {
  const location = useLocation();
  useVisitTracker(location.pathname);
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 lg:pt-20">
        {!hideBreadcrumbs && <Breadcrumbs articleTitle={breadcrumbTitle} />}
        {children}
      </main>
      <Footer />
      <FloatingCTA />
      
    </div>
  );
};

export default Layout;
